import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styles from './style.module.css';

export default function SelectedFileDisplay({ selectedFile, onFileRemove }) {
  const { t } = useTranslation();
  const [previewUrl, setPreviewUrl] = useState(null);

  const truncateFileName = (fileName) => {
    if (fileName.length <= 12) {
      return fileName;
    }

    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return fileName.slice(0, 9) + '...';
    }

    const name = fileName.slice(0, lastDotIndex);
    const extension = fileName.slice(lastDotIndex);

    if (name.length <= 9) {
      return fileName;
    }

    return name.slice(0, 6) + '...' + name.slice(-3) + extension;
  };

  useEffect(() => {
    if (selectedFile && selectedFile.type?.startsWith('image/')) {
      const url = URL.createObjectURL(selectedFile);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    } else {
      setPreviewUrl(null);
    }
  }, [selectedFile]);

  if (!selectedFile) {
    return null;
  }

  return (
    <div className={styles.selectedFileContainer}>
      {selectedFile.type && selectedFile.type.startsWith('image/') ? (
        <div className={styles.filePreviewContainer}>
          <img
            src={previewUrl}
            alt="Preview"
            className={styles.filePreview}
          />
        </div>
      ) : (
        <div className={styles.fileIconContainer}>
          <CloudUploadIcon sx={{ fontSize: 24, color: 'var(--text-secondary)' }} />
        </div>
      )}

      <div className={styles.fileInfo}>
        <div className={styles.fileName}>
          {truncateFileName(selectedFile.name)}
        </div>
        <div className={styles.fileSize}>
          {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
        </div>
      </div>

      <button
        className={styles.removeButton}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onFileRemove && onFileRemove();
        }}
      >
        {t('generic.remove')}
      </button>
    </div>
  );
}